export default {
  containers: {
    location_info: 'Informations sur le lieu',
    attributes: 'Attributs',
    links: 'Liens',
  },
  labels: {
    title: 'Titre',
    phone_number: 'Numéro de téléphone',
    description: 'Description',
    website: 'Site web',
    address: 'Adresse',
    regular_hours: 'Horaires réguliers',
    page_urls: 'URLs de la page',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
    twenty_four_hours: '24h',
    open_24_hours: 'Ouvert 24h/24',
    open_time: "Heure d'ouverture",
    close_time: 'Heure de fermeture',
    url: 'URL',
    provider_type: 'Type de fournisseur',
    provider_types: {
      merchant: 'Marchand',
      aggregator: 'Agrégateur',
    },
    place_action_type: 'Type',
    is_preferred: 'Préféré',
    place_action_types: {
      appointment: 'Prendre un rendez-vous',
      online_appointment: 'Prendre un rendez-vous en ligne',
      dining_reservation: 'Lien de réservation',
      food_ordering: 'Commander pour livraison et/ou à emporter',
      food_delivery: 'Lien de livraison',
      food_takeout: 'Lien à emporter',
      shop_online: 'Achats, livraison et/ou retrait possible',
    },
    no_links: 'Aucun lien disponible pour cette entreprise',
    url_menu: 'Lien du menu',
    url_reservations: 'Lien de réservation',
  },
  placeholders: {
    title: 'Titre',
    phone_number: 'Numéro de téléphone',
    description: 'Description',
    website: 'Site web',
    address: 'Adresse',
    regular_hours: 'Horaires réguliers',
    page_urls: 'URLs de la page',
    address_line_1: 'Adresse ligne 1',
    postal_code: 'Code postal',
    locality: 'Localité',
    region_code: 'Code région',
    language_code: 'Code langue',
    select_time: "Sélectionner l'heure",
    url: 'URL',
  },
  buttons: {
    submit: 'Envoyer',
    add: 'Ajouter',
    delete: 'Supprimer',
    generate_description: 'Générer une description par IA',
  },
  validation: {
    required: 'Ce champ est obligatoire',
    invalid_url: 'URL invalide',
  },
  toasts: {
    success: 'Modifications enregistrées !',
    description_generation_failed: 'Impossible de générer une description. Veuillez réessayer.',
  },
};
